module.exports = __webpack_public_path__ + "img/Group 447t2.d17fd901.svg";